import React, { ReactNode, createContext, useContext, useMemo } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { ModifyWorkspaceView } from '@futrli/views/views/workspaces/ModifyWorkspaceView/ModifyWorkspaceView';
import { useApiView } from '@futrli/views/hooks/useApiView';

import { useWorkspaceSettingsForm } from '../hooks/useWorkspaceSettingsForm';

interface WorkspaceSettingsContextProps {
  children?: ReactNode;
  workspaceId: string;
}

interface WorkspaceSettingsContextValues {
  form: ReturnType<typeof useWorkspaceSettingsForm>;
  view: ReturnType<typeof useApiView<ModifyWorkspaceView>>;
}

const defaultState = ({} as unknown) as WorkspaceSettingsContextValues;

export const WorkspaceSettingsContext = createContext(defaultState);

export const WorkspaceSettingsContextProvider = ({ children, workspaceId }: WorkspaceSettingsContextProps) => {
  const flags = useFlags();
  const view = useApiView(useMemo(() => new ModifyWorkspaceView(flags, workspaceId), [flags, workspaceId]));
  const form = useWorkspaceSettingsForm(view.state.workspace);

  const values: WorkspaceSettingsContextValues = {
    form,
    view
  };

  return <WorkspaceSettingsContext.Provider value={values}>{children}</WorkspaceSettingsContext.Provider>;
};

export const useWorkspaceSettingsContext = () => useContext(WorkspaceSettingsContext);
